import { LandResponseItem, LandResponseList } from '@/types/service-response'

export class Land {
  public constructor (
    readonly id: number,
    readonly name: string
  ) {}

  static createFromResponse (responseData: LandResponseList): Array<Land> {
    let result: Array<Land> = []
    if (responseData) {
      result = responseData.map((land: LandResponseItem ) => {
        return new Land(
          land.ID,
          land.Bezeichnung,
        )
      })
    }
    return result
  }
}
